import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=084d571b&scoped=true"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/shared-admin-styles.css?vue&type=style&index=0&id=084d571b&prod&scoped=true&lang=css&external"
import style1 from "./Admin.vue?vue&type=style&index=1&id=084d571b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084d571b",
  null
  
)

export default component.exports